import moment from "moment";

function matchMonth(month, year, datum) {
  if (!datum) return false;
  const d = moment(datum.timestamp);
  const m = d.utc().month();
  const y = d.utc().year();

  return m === month && y === year;
}

/**
 * @param {array} data array of objects with a timestamp and one or more value properties
 * @argument {instanceOf(moment)} timestamp moment data against which to filter
 * @returns {array} Array of all objects that fall within supplied date month
 */
export const filterByMonth = (data = [], timestamp) => {
  const filterDate = moment(timestamp);
  const month = filterDate.utc().month();
  const year = filterDate.utc().year();

  return data.filter(matchMonth.bind(null, month, year));
};

export const getOneMonthAgo = (dateObj) =>
  moment(dateObj).subtract(1, "months").utc();

export const sumValues = (values = [], key) =>
  values.reduce((prev, curr) => prev + Number(curr[key]), 0) || 0;

export const getMonthTotal = (data, date, key) =>
  sumValues(filterByMonth(data, date), key);

function sortByDescendingTimestamp(left, right) {
  return moment.utc(right.timestamp).diff(moment.utc(left.timestamp));
}

/**
 * Returns a single value from the input data that matches the year & month of the input datetime.
 * If multiple objects match the input year/month, the most recent object will be selected.
 * @param {array} data Array of objects with timestamp and one or more value properties
 * @param {instanceOf(moment)} date  moment data against which to filter
 * @param {*} key Key of object to target in data for return value
 * @returns {string} Matching value for given date, or '0' if no matches are found
 */
export const getMonthValue = (data, date, key) => {
  const matchList = filterByMonth(data, date).sort(sortByDescendingTimestamp);

  return matchList.length > 0 ? matchList[0][key] : 0;
};

/**
 * @param {array} data Array of objects with timestamp and one or more value properties
 * @param {instanceOf(moment)} date moment data against which to filter
 * @param {string} key Key of object to target in data for return value
 * @returns {number} Average of all values within given month from dataset
 */
export const getMonthAverage = (data = [], date, key) => {
  // If the array is empty, return 0
  if (data.length < 1) return 0;

  // Get month data and exit early if no data exists
  const monthData = filterByMonth(data, date);
  if (monthData.length < 1) return 0;

  const total = sumValues(monthData, key);
  return total / monthData.length;
};
